import { Button } from "@chakra-ui/react";

const ButtonPrimary = ({ children, disabled, loadingText = "", isLoading, icon, type = "submit" }) => {
    return (
        <Button
            isDisabled={disabled}
            isLoading={isLoading}
            loadingText={loadingText}
            leftIcon={icon}
            type={type}
            colorScheme='brand'
            className={`flex !h-14 items-center justify-center mt-2 w-full rounded-xl bg-brand-500 !py-[14px] text-base font-medium text-white transition duration-200 dark:bg-brand-400 dark:text-white ${disabled ? '' : 'hover:bg-brand-600 active:bg-brand-700 dark:hover:bg-brand-300 dark:active:bg-brand-200'}`}
        >
            {children}
        </Button>
    );
};

export default ButtonPrimary;